export const Roles = Object.freeze({
  DOCTOR_ANALYST: "DOCTOR_ANALYST",
  ANALYST: "ANALYST",
  GUEST_ANALYST: "GUEST_ANALYST",
  PATHOLOGY_ANALYST: "PATHOLOGY_ANALYST",
  LUNG_ANALYST: "LUNG_ANALYST",
});

export default Roles;
